import { Box, Collapse, Divider, Grid, IconButton, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import 'antd/dist/antd.css'
import useStyles, { ButtonAddDiagnosis } from 'features/setting/treatments/operatives/style'

/** API */
import ClinicFeeApi from 'api/setting/treatments/clinic-fee.api'
import DiagnosisApi from 'api/setting/treatments/diagnosis.api'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'
import OperativeUnitApi from 'api/setting/treatments/operative-unit.api'
import OperativeApi from 'api/setting/treatments/operative.api'
import { routeName } from 'routes/routes-name'

/** UTILS || SLICE */
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { icons } from 'constants/images'
import { colors } from 'constants/theme'
import _ from 'lodash'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import TextInput from 'new-components/inputs/text-input'
import { checkAddons, checkPackage, getClinicInfo, numberFormat, numberOnly, numberOnlyDecimal, stripLeadingZeros } from 'utils/app.utils'
import { PACKAGE_ADDONS } from 'constants/package'
import FormOpetaivesBranch, { dataManageProps, initDataManage } from './form-opetaives-branch'
import BoxSelectMedPd, { BindProductProps } from './form-opetatives-products'

type VitalSignInput = {
  id: string
  text: string
  label: string
  isRequired: boolean
}

type VitalSignState = {
  isVitalSign: boolean
  inputName: VitalSignInput[]
}

const initialVitalSignInputs: VitalSignInput[] = [
  { id: 'weight', text: 'WEIGHT', label: 'น้ำหนัก (Kg)', isRequired: false },
  { id: 'height', text: 'HEIGHT', label: 'ส่วนสูง (Cm)', isRequired: false },
  { id: 'bloodPressure', text: 'SYSTOLIC_BLOOD_PRESSURE', label: 'ความดันโลหิต', isRequired: false },
  { id: 'waistline', text: 'WAISTLINE', label: 'รอบเอว', isRequired: false },
  { id: 'temperature', text: 'TEMPERATURE', label: 'อุณหภูมิ', isRequired: false },
  { id: 'pulseRate', text: 'PULSE_RATE', label: 'อัตราชีพจร', isRequired: false },
  { id: 'heartRate', text: 'HEART_RATE', label: 'อัตราเต้นหัวใจ', isRequired: false },
  { id: 'regIrreq', text: 'REG_LRREQ', label: 'Reg/Irreq', isRequired: false },
  { id: 'rr', text: 'RR', label: 'RR', isRequired: false },
  { id: 'o2Sat', text: 'O2SAT', label: 'O2Sat(%)', isRequired: false }
]

const initialVitalSignState: VitalSignState = {
  isVitalSign: false,
  inputName: initialVitalSignInputs
}

const initStateErrorMessage = {
  OPERATIVE_TYPE_ID: ``,

  OPERATIVE_CODE: ``,
  IS_DUPLICATE_OPERATIVE_CODE: ``,
  OPERATIVE_CODE_STRING_BASE: ``,
  OPERATIVE_CODE_STRING_EMPTY: ``,
  OPERATIVE_CODE_MAXIMUM_LENGTH: ``,
  OPERATIVE_CODE_ANY_REQUIRED: ``,

  OPERATIVE_NAME: ``,
  IS_DUPLICATE_OPERATIVE_NAME: ``,
  OPERATIVE_NAME_STRING_BASE: ``,
  OPERATIVE_NAME_STRING_EMPTY: ``,
  OPERATIVE_NAME_MAXIMUM_LENGTH: ``,
  OPERATIVE_NAME_ANY_REQUIRED: ``,

  OPERATIVE_NAME_EN: ``,
  IS_DUPLICATE_OPERATIVE_NAME_EN: ``,
  OPERATIVE_NAME_EN_STRING_BASE: ``,
  OPERATIVE_NAME_EN_STRING_EMPTY: ``,
  OPERATIVE_NAME_EN_MAXIMUM_LENGTH: ``,
  OPERATIVE_NAME_EN_ANY_REQUIRED: ``,

  OPERATIVE_COST_PRICE: ``,
  COST_PRICE_ANY_REQUIRED: ``,
  COST_PRICE_NUMBER: ``,
  OPERATIVE_SALE_PRICE: ``,
  SALE_PRICE_ANY_REQUIRED: ``,
  SALE_PRICE_NUMBER: ``,

  OPERATIVE_UNIT_ID: ``,
  OPERATIVE_DIAGNOSES_UNIQUE: ``,

  EMPTY_OPERATIVE_NAME: ``,
  EMPTY_OPERATIVE_NAME_EN: ``,
  EMPTY_OPERATIVE_CODE: ``,
  EMPTY_OPERATIVE_TYPE: ``,
  EMPTY_OPERATIVE_UNIT: ``,
  EMPTY_OPERATIVE_COST: ``,
  EMPTY_OPERATIVE_SALE: ``,
  DIAGNOSIS_NAME: '',
  MIN_SALE_PRICE: ``,
  MAX_SALE_PRICE: ``,
  MAX_SALE_PRICE_RANGE: ``,
  MAX_SALE_PRICE_ZERO: ``
}
interface DiagnosesInterface {
  diagnosisId: number | null
  diagnosisText: string
}
export default function FormOperatives() {
  const classes = useStyles()
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const branchInfo = getClinicInfo()

  const [load, setLoad] = useState<boolean>(true)
  const [initLocation, setInitLocation] = useState({})

  const [operativeUnits, setOperativeUnits]: any = useState([])
  const [operativeTypes, setOperativeTypes]: any = useState([])
  const [defaultOperativeType, setDefaultOperativeType] = useState({ label: ``, value: `` })
  const [defaultOperativeUnit, setDefaultOperativeUnit] = useState({ label: ``, value: `` })

  const [diagnoses, setDiagnoses] = useState<DiagnosesInterface[]>([])

  /** DATA OPTION */
  const [diagnosesOption, setDiagnosesOption] = useState<any[]>([])
  const [clinicFeeOptions, setClinicFeeOptions] = useState<any[]>([])
  const [clinicFeeSelected, setClinicFeeSelected] = useState<any[]>([])

  const [operativeId, setOperativeId] = useState<number>()
  const [operativeTypeId, setOperativeTypeId] = useState<number>()
  const [operativeUnitId, setOperativeUnitId] = useState<number>()
  const [operativeCode, setOperativeCode] = useState('')
  const [operativeName, setOperativeName] = useState('')
  const [operativeNameEn, setOperativeNameEn] = useState('')
  const [operativeCostPrice, setOperativeCostPrice] = useState('')
  const [operativeSalePrice, setOperativeSalePrice] = useState('')
  const [minSalePrice, setMinSalePrice] = useState('')
  const [maxSalePrice, setMaxSalePrice] = useState('')
  const [isPriceRange, setIsPriceRange] = useState<'0' | '1'>('0')
  const [operativeClinicFee, setOperativeClinicFee] = useState<any[]>([])
  const [operativeStatus, setOperativeStatus] = useState('')
  const [disabledBtnAddDiagnosis, setDisabledBtnAddDiagnosis] = useState(false)
  const [operativeFixCode, setOperativeFixCode] = useState<'0' | '1'>('0')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [operativeProducts, setOperativeProducts] = useState<BindProductProps[]>([])
  const [productsError, setProductError] = useState<boolean>(false)
  const [errorDiagnosis, setErrorDiagnosis] = useState(false)
  const [branchPrice, setBranchPrice] = useState<'0' | '1'>('0')
  const [isXray, setIsXray] = useState<'0' | '1'>('0')
  const [popManageBranch, setPopManageBranch] = useState<boolean>(false)
  const [operativePrice, setOperativePrice] = useState<dataManageProps>(initDataManage)
  const [operativeSalePriceBranch, setOperativeSalePriceBranch] = useState<string>('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [vitalSignState, setVitalSignState] = useState<VitalSignState>(initialVitalSignState)
  const [followUpState, setFollowUpState] = useState('0')

  const disabledBtnAdd = useSelector((state: any) => state.buttons.isDisabled)
  const { id }: any = useParams()

  const loadData = useCallback(async () => {
    const respDiagnosis = await DiagnosisApi.findAll({ pageLimit: 100, search: '', status: 'ACTIVE' })
    if (respDiagnosis.status === 200) {
      setDiagnosesOption(respDiagnosis.data)
    }
  }, [])

  useEffect(() => {
    loadData()
    handleChangeClinicFee()
  }, [loadData])

  const handleChangeOperativeUnit = useCallback(async (search = '') => {
    const respOperativeUnits = await OperativeUnitApi.findAll({ pageLimit: 100, search: search, status: 'ACTIVE' })
    if (respOperativeUnits.status === 200) {
      const options = respOperativeUnits.data.map((value: any) => {
        return { label: value.operativeUnitName, value: value.operativeUnitId }
      })
      setOperativeUnits(options)
    }
  }, [])

  const handleChangeOperativeType = useCallback(async (search = '') => {
    const respOperativeTypes = await OperativeTypeApi.findAll({ pageLimit: 100, search: search, status: 'ACTIVE' })
    if (respOperativeTypes.status === 200) {
      const options = respOperativeTypes.data.map((value: any) => {
        return { label: value.operativeTypeName, value: value.operativeTypeId }
      })
      setOperativeTypes(options)
    }
    return respOperativeTypes
  }, [])

  const handleChangeClinicFee = useCallback(async (search = '') => {
    const respClinicFees = await ClinicFeeApi.findAll({ pageLimit: 100, search: search, status: 'ACTIVE' })
    if (respClinicFees.status === 200) {
      const options = respClinicFees.data.map((value: any) => {
        return { label: value.clinicFeeName, value: value.clinicFeeId, price: Number(value.price || 0) }
      })
      setClinicFeeOptions(options)
    }
  }, [])

  useEffect(() => {
    setInitLocation(location)
    const { state }: any = initLocation
    if (state) onEdit(state)
    else {
      handleChangeOperativeUnit()
      handleChangeOperativeType()
      handleChangeClinicFee()
      setLoad(false)
    }
  }, [location, initLocation])

  const onEdit = async (objData: any) => {
    setLoad(true)
    if (objData) {
      setOperativeId(objData.operativeId)
      setFollowUpState(objData.followUpStage)
      setOperativeUnitId(objData.operativeUnitId)
      setOperativeCode(objData.operativeCode)
      setOperativeName(objData.operativeName)
      setOperativeNameEn(objData.operativeNameEn)
      setOperativeCostPrice(objData.costPrice)
      setOperativeSalePrice(objData.salePrice)
      setMinSalePrice(objData.minSalePrice !== null && objData.minSalePrice !== undefined ? String(objData.minSalePrice) : '')
      setMaxSalePrice(objData.maxSalePrice !== null && objData.maxSalePrice !== undefined ? String(objData.maxSalePrice) : '')
      setIsPriceRange(objData.isPriceRange || '0')
      setOperativeStatus(objData.status)
      setOperativeFixCode(objData.fixCode)

      if (objData.isVitalSign) {
        try {
          const parsedData = JSON.parse(objData.isVitalSign)
          const reconciledInputs = initialVitalSignInputs.map(initialInput => {
            const apiInput = parsedData.inputName.find((item: any) => item.id === initialInput.id)
            return {
              ...initialInput,
              isRequired: apiInput ? apiInput.isRequired : false
            }
          })
          setVitalSignState({
            isVitalSign: parsedData.isVitalSign || false,
            inputName: reconciledInputs
          })
        } catch (error) {
          console.error('Failed to parse operativeVitalSign:', error)
          setVitalSignState(initialVitalSignState)
        }
      } else {
        setVitalSignState(initialVitalSignState);
      }

      setBranchPrice(objData?.branchPrice || '0')
      setIsXray(objData?.isXray || '0')

      const newOperativeProducts = objData?.operativeProducts?.map((item: any) => {
        return {
          ...item,
          itemTypeName: item?.productTypeName,
          itemTypeId: item?.productTypeId,
          itemName: item?.productName,
          itemId: item?.productId,
        }
      }) || []
      setOperativeProducts(newOperativeProducts || [])

      const groupPrice: any[] = []
      objData?.operativePrice?.forEach((item: any) => {
        if (branchInfo?.branchId === item.branchId && objData?.branchPrice !== '0') {
          setOperativeSalePrice(item.price)
        }
        if (!groupPrice?.some((info: any) => info?.price === item.price)) {
          groupPrice.push({ branchId: [item.branchId], price: item.price })
        } else {
          const idx = groupPrice.findIndex((info) => info?.price === item.price)
          groupPrice[idx] = { ...groupPrice[idx], branchId: [...groupPrice[idx]?.branchId, item.branchId] }
        }
      })
      setOperativePrice({ ...operativePrice, branches: groupPrice || [] })


      if (objData.operativeClinicFees.length) {
        setOperativeClinicFee(objData.operativeClinicFees.map(({ clinicFeeId }: any) => clinicFeeId))
        setClinicFeeSelected(
          objData.operativeClinicFees.map((value: any) => {
            return { label: value.clinicFeeText, value: value.clinicFeeId, price: Number(value.price || 0) }
          })
        )
      }
      if (objData.operativeDiagnoses.length) {
        const temp: DiagnosesInterface[] = objData.operativeDiagnoses.map((di: any) => ({ diagnosisId: di.diagnosisId, diagnosisText: di.diagnosisText }))
        setDiagnoses(temp)
      }
      await handleChangeOperativeUnit(objData?.operative_unit?.operativeUnitName || '')
      const checkOpType = await handleChangeOperativeType(objData?.operative_type?.operativeTypeName || '')
      if (objData?.operative_unit) setDefaultOperativeUnit({ label: objData?.operative_unit?.operativeUnitName || '', value: objData?.operative_unit?.operativeUnitName || '' })
      if (objData?.operative_type && checkOpType?.data?.length) {
        setOperativeTypeId(objData.operativeTypeId)
        setDefaultOperativeType({ label: objData?.operative_type?.operativeTypeName || '', value: objData?.operative_type?.operativeTypeName || '' })
      }
      setLoad(false)
    }
  }

  const getValidationErrors = () => {
    const nextErrors = {
      EMPTY_OPERATIVE_NAME: !operativeName ? t('OPERATIVE.MESSAGE.OPERATIVE_NAME') : '',
      EMPTY_OPERATIVE_CODE: !operativeCode ? t('OPERATIVE.MESSAGE.OPERATIVE_CODE') : '',
      EMPTY_OPERATIVE_TYPE: !operativeTypeId ? t('OPERATIVE_TYPE.MESSAGE.OPERATIVE_TYPE_NAME') : '',
      EMPTY_OPERATIVE_UNIT: !operativeUnitId ? t('OPERATIVE_UNIT.MESSAGE.OPERATIVE_UNIT_NAME') : '',
      EMPTY_OPERATIVE_COST: operativeCostPrice === '' ? t('OPERATIVE.MESSAGE.OPERATIVE_COST_PRICE') : '',
      EMPTY_OPERATIVE_SALE: operativeSalePrice === '' ? t('OPERATIVE.MESSAGE.OPERATIVE_SALE_PRICE') : '',
      DIAGNOSIS_NAME:
        diagnoses.length > 0 && diagnoses.every((e: any) => e.diagnosisId === null) ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_NAME') : '',

      MIN_SALE_PRICE: '',
      MAX_SALE_PRICE: '',
      MAX_SALE_PRICE_RANGE: '',
      MAX_SALE_PRICE_ZERO: '',
      // keep consistent key usage with existing helperText
      OPERATIVE_SALE_PRICE: '',
    }

    if (isPriceRange === '1') {
      const hasSalePrice = operativeSalePrice !== ''
      const hasMinPrice = minSalePrice !== '' && minSalePrice !== null && minSalePrice !== undefined
      const hasMaxPrice = maxSalePrice !== '' && maxSalePrice !== null && maxSalePrice !== undefined

      if (!hasMinPrice) nextErrors.MIN_SALE_PRICE = t('OPERATIVE.MESSAGE.MIN_SALE_PRICE')
      if (!hasMaxPrice) nextErrors.MAX_SALE_PRICE = t('OPERATIVE.MESSAGE.MAX_SALE_PRICE')

      // ตรวจสอบว่า maxSalePrice เป็น 0 หรือไม่
      if (hasMaxPrice && (maxSalePrice === '0' || Number(maxSalePrice) === 0)) {
        nextErrors.MAX_SALE_PRICE_ZERO = t('OPERATIVE.MESSAGE.MAX_SALE_PRICE_ZERO')
      }

      // Only do numeric/range comparisons when all inputs are present.
      if (hasMinPrice && hasMaxPrice && hasSalePrice) {
        const minPrice = Number(minSalePrice) || 0
        const maxPrice = Number(maxSalePrice) || 0
        const salePrice = Number(operativeSalePrice) || 0

        // maxPrice ต้องมากกว่าหรือเท่ากับ minPrice
        if (maxPrice < minPrice) {
          nextErrors.MAX_SALE_PRICE_RANGE = t('OPERATIVE.MESSAGE.MAX_SALE_PRICE_RANGE')
        }

        // minSalePrice ห้ามมากกว่า operativeSalePrice
        if (minPrice > salePrice) {
          nextErrors.MIN_SALE_PRICE = t('OPERATIVE.MESSAGE.MIN_SALE_PRICE_RANGE')
        }

        // maxSalePrice ห้ามน้อยกว่า operativeSalePrice
        if (maxPrice < salePrice) {
          nextErrors.MAX_SALE_PRICE_RANGE = t('OPERATIVE.MESSAGE.MAX_SALE_PRICE_RANGE')
        }
      }
    }

    return nextErrors
  }

  const submit = () => {
    setDisabledSubmit(true)

    if (handleCheckProduct()) {
      setDisabledSubmit(false)
      return
    }

    const newOperativeProducts = operativeProducts.map((item) => {
      return { productId: item.itemId, qty: item.qty, branchId: item.branchId }
    })

    const newOperativePrice: any[] = []
    operativePrice?.branches?.forEach((item: any) => {
      item?.branchId?.forEach((info: number) => {
        newOperativePrice.push({ branchId: info, price: item.price, minPrice: item?.minPrice, maxPrice: item?.maxPrice })
      })
    })

    if (vitalSignState.inputName.filter(e => e.isRequired).length === 0 && vitalSignState.isVitalSign) {
      setDisabledSubmit(false)
      return notiError(t('OPERATIVE_TYPE.MESSAGE.SELECT_VITAL_SIGN'))
    }

    const validationErrors = getValidationErrors()
    const hasValidationError = Object.values(validationErrors).some(Boolean)
    if (hasValidationError) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...validationErrors })
    }

    const clinicFees: any[] = []
    const tempClinicFees: any[] = []
    for (const val of operativeClinicFee) {
      if (tempClinicFees.indexOf(val) === -1) {
        tempClinicFees.push(val)
        clinicFees.push({ clinicFeeId: val })
      }
    }

    const vitalSignPayload = {
      isVitalSign: vitalSignState.isVitalSign,
      inputName: vitalSignState.inputName.map(({ id, text, isRequired }) => ({ id, text, isRequired }))
    }

    const objSave: any = {
      operativeTypeId,
      operativeCode,
      operativeName,
      operativeNameEn,
      costPrice: operativeCostPrice,
      salePrice: operativeSalePrice,
      minSalePrice: minSalePrice || null,
      maxSalePrice: maxSalePrice || null,
      isPriceRange: isPriceRange,
      operativeUnitId,
      operativeDiagnoses: diagnoses,
      operativeClinicFees: clinicFees,
      fixCode: operativeFixCode,
      branchPrice: branchPrice,
      isXray: isXray,
      operativePrice: newOperativePrice,
      operativeProducts: newOperativeProducts,
      isVitalSign: JSON.stringify(vitalSignPayload),
      followUpStage: followUpState
    }

    if (!operativeTypeId) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_TYPE_ID: t('OPERATIVE.MESSAGE.OPERATIVE_TYPE_ID') } })
    }
    if (!operativeCode) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_CODE: t('OPERATIVE.MESSAGE.OPERATIVE_CODE') } })
    }
    if (!operativeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_NAME: t('OPERATIVE.MESSAGE.OPERATIVE_NAME') } })
    }
    if (operativeCostPrice === '') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_COST_PRICE: t('OPERATIVE.MESSAGE.OPERATIVE_COST_PRICE') } })
    }
    if (operativeSalePrice === '') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_SALE_PRICE: t('OPERATIVE.MESSAGE.OPERATIVE_SALE_PRICE') } })
    }
    if (!operativeUnitId) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_UNIT_ID: t('OPERATIVE.MESSAGE.OPERATIVE_UNIT_ID') } })
    }
    if (diagnoses.length) {
      if (diagnoses.map((dg: DiagnosesInterface) => dg.diagnosisId).includes(null)) {
        setErrorDiagnosis(true)
        setDisabledSubmit(false)
        return setErrorMessage({ ...errorMessage, ...{ DIAGNOSIS_NAME: t('OPERATIVE.MESSAGE.DIAGNOSES_NUMBER') } })
      }
      let newDiagnoses: any = []
      _.forEach(diagnoses, (d) => {
        if (_.find(diagnosesOption, { diagnosisId: d.diagnosisId })) newDiagnoses = [...newDiagnoses, d]
      })
      objSave.operativeDiagnoses = newDiagnoses
    }

    if (operativeId) update(operativeId, objSave)
    else create(objSave)
  }

  const create = (payload: any) => {
    OperativeApi.create(payload)
      .then((res: any) => {
        notiSuccess(t('OPERATIVE.MESSAGE.SUCCESS.CREATE'), '', null, () => loadData())
        history.push(routeName.operatives)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE.MESSAGE.${err.message}`) } })
      })
  }

  const update = (updateId: any, payload: any) => {
    setDisabledSubmit(true)

    const validationErrors = getValidationErrors()
    const hasValidationError = Object.values(validationErrors).some(Boolean)
    if (hasValidationError) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...validationErrors })
    }

    if (diagnoses.map((dg: DiagnosesInterface) => dg.diagnosisId).includes(null)) {
      setDisabledSubmit(false)
      setErrorDiagnosis(true)
      return setErrorMessage({ ...errorMessage, ...{ DIAGNOSIS_NAME: t('OPERATIVE.MESSAGE.DIAGNOSES_NUMBER') } })
    }

    payload.status = operativeStatus
    OperativeApi.update(Number(updateId), payload)
      .then((res: any) => {
        notiSuccess(t(`OPERATIVE.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
          loadData()
        })
        history.push(routeName.operatives)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        if (err.message === 'OPERATIVE_DIAGNOSES_UNIQUE') return notiError(t(`OPERATIVE.MESSAGE.${err.message}`))
        else setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE.MESSAGE.${err.message}`) } })
      })
  }

  useEffect(() => {
    if (_.some(diagnoses, (diagnosis: any) => diagnosis.diagnosisId === '' || diagnosis.diagnosisId === 0 || diagnosis.diagnosisId === null)) {
      setDisabledBtnAddDiagnosis(true)
    } else {
      setDisabledBtnAddDiagnosis(false)
    }
  }, [diagnoses])

  const addDiagnosis = () => {
    const temp: DiagnosesInterface[] = [...diagnoses]
    temp.push({ diagnosisId: null, diagnosisText: '' })
    setDiagnoses(temp)
  }

  const deleteDiagnoses = (index: any) => {
    setErrorDiagnosis(false)
    setDiagnoses(_.filter(diagnoses, (d: any, i: any) => i !== index))
  }

  const handleSelectDiagnosis = (val: any, index: any) => {
    const di: any = diagnosesOption.find((opt) => opt.diagnosisId === val?.value)
    if (di) {
      const temp: DiagnosesInterface[] = [...diagnoses]
      temp[index] = { diagnosisId: di.diagnosisId, diagnosisText: di.diagnosisName }
      setDiagnoses(temp)
    }
  }

  const clearErrorMessage = () => setErrorMessage(initStateErrorMessage)

  const handleCheckProduct = () => {
    const temp: BindProductProps[] = [...operativeProducts]
    const checkTemp = temp.some((item) => !item?.group || !item?.itemId || !item?.itemTypeId || !item?.qty || !item?.branchId?.length)
    setProductError(checkTemp)
    return checkTemp
  }

  const addProducts = () => {
    if (handleCheckProduct()) {
      return
    }
    const temp: BindProductProps[] = [...operativeProducts]
    const newTemp: BindProductProps = {}
    temp.push(newTemp)
    setOperativeProducts(temp)
  }

  const handleProduct = (val: BindProductProps, index: number) => {
    const temp: BindProductProps[] = [...operativeProducts]
    temp[index] = val
    setOperativeProducts(temp)
  }

  const handleDelProduct = (index: number) => {
    const temp: BindProductProps[] = [...operativeProducts].filter((item, idx: number) => idx !== index)
    setOperativeProducts(temp)
  }

  const onOpenModalManageBranch = () => {
    setPopManageBranch(true)
    // dispatch(showModal())
  }

  const onCloseModalManageBranch = () => {
    setPopManageBranch(false)
    // dispatch(resetModal())
  }

  const handleChangeManageBranch = (value: dataManageProps) => {
    clearErrorMessage()
    const branchCurrent: number = branchInfo?.branchId || 0
    if (value?.branches?.length && branchCurrent) {
      const newValue = value.branches.find((item) => item?.branchId?.length && item.branchId.includes(branchCurrent))?.price || ''
      setOperativeSalePriceBranch(String(newValue))
    } else {
      setOperativeSalePriceBranch('')
    }
    setOperativePrice(value)
  }

  const handleChangeBranchPrice = () => {
    // ถ้าเปิดใช้งาน "ราคาช่วง" อยู่ ไม่อนุญาตให้จัดการราคาแยกตามสาขา
    if (isPriceRange === '1') return
    const newBranchPrice = branchPrice === '0' ? '1' : '0'
    const branchCurrent: number = branchInfo?.branchId || 0

    if (newBranchPrice === '0') {
      setOperativeSalePriceBranch('')
    } else {
      const newValue = operativePrice.branches.find((item) => item?.branchId?.length && item.branchId.includes(branchCurrent))?.price || ''
      setOperativeSalePriceBranch(String(newValue))
    }

    setBranchPrice(newBranchPrice)
  }

  const handleChangeOperativePrice = (event: any) => {
    setOperativeSalePrice(numberOnly(event))
    clearErrorMessage()
  }

  const handleIsVitalSignChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    setVitalSignState(prevState => ({
      ...prevState,
      isVitalSign: isChecked,
      inputName: isChecked ? prevState.inputName : prevState.inputName.map(item => ({ ...item, isRequired: false }))
    }))
  }

  const handleRequiredChange = (id: string) => {
    setVitalSignState(prevState => ({
      ...prevState,
      inputName: prevState.inputName.map(item =>
        item.id === id ? { ...item, isRequired: !item.isRequired } : item
      )
    }))
  }

  const handleRequiredAllChange = (itemsToUpdate: VitalSignInput[], newCheckedState: boolean) => {
    const idsToUpdate = itemsToUpdate.map(item => item.id);
    setVitalSignState(prevState => ({
      ...prevState,
      inputName: prevState.inputName.map(item =>
        idsToUpdate.includes(item.id)
          ? { ...item, isRequired: newCheckedState }
          : item
      ),
    }));
  };

  const splitIndex = 6;
  const leftColumnItems = vitalSignState.inputName.slice(0, splitIndex);
  const rightColumnItems = vitalSignState.inputName.slice(splitIndex);

  const isLeftAllChecked = leftColumnItems.length > 0 && leftColumnItems.every(item => item.isRequired);
  const isRightAllChecked = rightColumnItems.length > 0 && rightColumnItems.every(item => item.isRequired);

  return (
    <>
      <Box>
        <Loading show={load} />
        <HeaderLabel
          onSubmit={submit}
          text={id ? t('OPERATIVE.TITLE_UPDATE') : t('OPERATIVE.TITLE_CREATE')}
          navigator={{ previousTo: routeName.operatives, previousTitle: t('OPERATIVE.TITLE'), currentTitle: id ? t('OPERATIVE.TITLE_UPDATE') : t('OPERATIVE.TITLE_CREATE') }}
          goBack={routeName.operatives}
          disabled={disabledSubmit}
        />
        <Box padding="24px">
          <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
            <Grid container spacing={2}>
              <Grid item sm={12} md={6} lg={4}>
                <TextInput
                  onChange={(event) => {
                    setOperativeName(event.target.value)
                    clearErrorMessage()
                  }}
                  value={operativeName}
                  helperText={
                    errorMessage.OPERATIVE_NAME ||
                    errorMessage.IS_DUPLICATE_OPERATIVE_NAME ||
                    errorMessage.OPERATIVE_NAME_STRING_BASE ||
                    errorMessage.OPERATIVE_NAME_STRING_EMPTY ||
                    errorMessage.OPERATIVE_NAME_MAXIMUM_LENGTH ||
                    errorMessage.OPERATIVE_NAME_ANY_REQUIRED ||
                    errorMessage.EMPTY_OPERATIVE_NAME
                  }
                  label={t('OPERATIVE.INPUT.OPERATIVE_NAME')}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <TextInput
                  onChange={(event) => {
                    setOperativeNameEn(event.target.value)
                    clearErrorMessage()
                  }}
                  value={operativeNameEn}
                  helperText={errorMessage.IS_DUPLICATE_OPERATIVE_NAME_EN}
                  label={t('OPERATIVE.INPUT.OPERATIVE_NAME_EN')}
                  fullWidth
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px' }} />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>{t('OPERATIVE.OPERATIVE_DETAIL')}</Typography>
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <TextInput
                  onChange={(event) => {
                    setOperativeCode(event.target.value)
                    clearErrorMessage()
                  }}
                  value={operativeCode}
                  helperText={
                    errorMessage.OPERATIVE_CODE ||
                    errorMessage.IS_DUPLICATE_OPERATIVE_CODE ||
                    errorMessage.OPERATIVE_CODE_STRING_BASE ||
                    errorMessage.OPERATIVE_CODE_STRING_EMPTY ||
                    errorMessage.OPERATIVE_CODE_MAXIMUM_LENGTH ||
                    errorMessage.OPERATIVE_CODE_ANY_REQUIRED ||
                    errorMessage.EMPTY_OPERATIVE_CODE
                  }
                  label={t('OPERATIVE.INPUT.OPERATIVE_CODE')}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <AutocompleteSelect
                  labelId="operative-type"
                  key={`operative-type`}
                  inputLabel={t('OPERATIVE.INPUT.OPERATIVE_TYPE')}
                  noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                  options={operativeTypes}
                  maxHight={'180px'}
                  onchange={(e, val) => {
                    clearErrorMessage()
                    if (val) {
                      const { name, value }: any = val
                      setOperativeTypeId(value)
                      setDefaultOperativeType(val)
                    }
                  }}
                  onInputChange={(event: any, newValue: any) => handleChangeOperativeType(newValue)}
                  onOpen={(e: any) => {
                    handleChangeOperativeType('')
                  }}
                  disableClearable
                  required
                  errMessage={errorMessage.OPERATIVE_TYPE_ID || errorMessage.EMPTY_OPERATIVE_TYPE}
                  value={defaultOperativeType}
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <AutocompleteSelect
                  labelId="operative-unit"
                  key={`operative-unit`}
                  inputLabel={t('OPERATIVE.INPUT.OPERATIVE_UNIT')}
                  noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                  options={operativeUnits}
                  maxHight={'180px'}
                  onchange={(e, val) => {
                    clearErrorMessage()
                    if (val) {
                      const { name, value }: any = val
                      setOperativeUnitId(value)
                      setDefaultOperativeUnit(val)
                    }
                  }}
                  onInputChange={(event: any, newValue: any) => handleChangeOperativeUnit(newValue)}
                  onOpen={(e: any) => {
                    handleChangeOperativeUnit('')
                  }}
                  disableClearable
                  required
                  errMessage={errorMessage.OPERATIVE_UNIT_ID || errorMessage.EMPTY_OPERATIVE_UNIT}
                  value={defaultOperativeUnit}
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <TextInput
                  onChange={(event) => {
                    const raw = event.target.value
                    if (raw === '') setOperativeCostPrice('')
                    else if (Number(raw) === 0) setOperativeCostPrice('0')
                    else {
                      const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                      setOperativeCostPrice(cleaned)
                    }
                    clearErrorMessage()
                  }}
                  value={operativeCostPrice}
                  helperText={errorMessage.OPERATIVE_COST_PRICE || errorMessage.COST_PRICE_ANY_REQUIRED || errorMessage.COST_PRICE_NUMBER || errorMessage.EMPTY_OPERATIVE_COST}
                  label={t('OPERATIVE.INPUT.OPERATIVE_COST_PRICE')}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <TextInput
                  onChange={(event) => {
                    const raw = event.target.value
                    if (raw === '') setOperativeSalePrice('')
                    else if (Number(raw) === 0) setOperativeSalePrice('0')
                    else {
                      const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                      setOperativeSalePrice(cleaned)
                    }
                    clearErrorMessage()
                  }}
                  value={operativeSalePrice}
                  helperText={
                    errorMessage.OPERATIVE_SALE_PRICE ||
                    errorMessage.SALE_PRICE_ANY_REQUIRED ||
                    errorMessage.SALE_PRICE_NUMBER ||
                    errorMessage.EMPTY_OPERATIVE_SALE
                  }
                  label={t('OPERATIVE.INPUT.OPERATIVE_SALE_PRICE')}
                  required={true}
                  disabled={branchPrice === '1'}
                  fullWidth
                />
              </Grid>


              {/* Price Range Section */}
              {checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && (
                <Grid item sm={12} >
                  <Grid container flexDirection="row" alignItems="center" gap="16px"    >
                    <CheckboxButton
                      checked={isPriceRange === '1'}
                      label={t('OPERATIVE.INPUT.ENABLE_PRICE_RANGE') || 'เปิดใช้งานราคาช่วง'}
                      onChange={() => {
                        const nextIsPriceRange = isPriceRange === '0' ? '1' : '0'
                        setIsPriceRange(nextIsPriceRange)
                        setMinSalePrice('')
                        setMaxSalePrice('')
                        clearErrorMessage()
                        // ถ้าเปิด "ราคาช่วง" ให้ปิด "จัดการราคาแยกตามสาขา" เพื่อป้องกันเงื่อนไขชนกัน
                        if (nextIsPriceRange === '1') {
                          setBranchPrice('0')
                          setOperativeSalePriceBranch('')
                        }
                      }}
                    />

                    {isPriceRange === '1' && (
                      <Grid item sm={12} md={6} lg={4}>
                        <TextInput
                          onChange={(event) => {
                            const raw = event.target.value
                            if (raw === '') setMinSalePrice('')
                            else if (Number(raw) === 0) setMinSalePrice('0')
                            else {
                              const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                              const [intPart] = String(cleaned).split('.')
                              if (intPart.length <= 6) {
                                setMinSalePrice(cleaned)
                              }
                            }
                            clearErrorMessage()
                          }}
                          value={minSalePrice}
                          helperText={errorMessage.MIN_SALE_PRICE ||
                            (isPriceRange === '1' && minSalePrice && operativeSalePrice && Number(operativeSalePrice) < Number(minSalePrice) ? t('MEDICINE.MESSAGE.ERROR.SALE_PRICE_RANGE') : '')
                          }
                          label={t('OPERATIVE.INPUT.MIN_SALE_PRICE') || 'ราคาขายขั้นต่ำ'}
                          fullWidth
                        />
                      </Grid>
                    )}
                    {isPriceRange === '1' && (
                      <Grid item sm={12} md={6} lg={4}>
                        <TextInput
                          onChange={(event) => {
                            const raw = event.target.value
                            if (raw === '') setMaxSalePrice('')
                            else if (Number(raw) === 0) setMaxSalePrice('0')
                            else {
                              const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                              const [intPart] = String(cleaned).split('.')
                              if (intPart.length <= 6) {
                                setMaxSalePrice(cleaned)
                              }
                            }
                            clearErrorMessage()
                          }}
                          value={maxSalePrice}
                          helperText={errorMessage.MAX_SALE_PRICE_ZERO || errorMessage.MAX_SALE_PRICE || errorMessage.MAX_SALE_PRICE_RANGE || (isPriceRange === '1' && maxSalePrice && operativeSalePrice && Number(operativeSalePrice) > Number(maxSalePrice) ? t('MEDICINE.MESSAGE.ERROR.SALE_PRICE_RANGE') : '')}
                          label={t('OPERATIVE.INPUT.MAX_SALE_PRICE') || 'ราคาขายขั้นสูงสุด'}
                          fullWidth
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}

              <Grid item sm={12} md={6} lg={4}>
                <AutocompleteSelect
                  multiple
                  labelId="label-clinic-fees"
                  inputLabel={t('OPERATIVE.INPUT.OPERATIVE_CLINIC_FEES')}
                  noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                  options={clinicFeeOptions}
                  getOptionLabel={(option: any) => `${option.label} (${numberFormat(option.price, 0, 0)} ${t('CURRENCY_CHANGE.TH')})`}
                  renderOption={(props, option: any) => (
                    <Box
                      key={option.value}
                      component="li"
                      {...props}
                      sx={{
                        pointerEvents: _.find(clinicFeeSelected, { value: option.value }) ? 'none' : 'auto',
                        color: _.find(clinicFeeSelected, { value: option.value }) ? colors.disabledGray : colors.textPrimary,
                        svg: {
                          filter: _.find(clinicFeeSelected, { value: option.value }) ? 'grayscale(1)' : 'grayscale(0)'
                        }
                      }}
                    >
                      {`${option.label} (${numberFormat(option.price, 0, 0)} ${t('CURRENCY_CHANGE.TH')})`}
                    </Box>
                  )}
                  onchange={(e, val) => {
                    setClinicFeeSelected(val)
                    if (val) {
                      setOperativeClinicFee(val.map(({ value }: any) => value))
                    }
                  }}
                  onInputChange={(event: any, newValue: any) => handleChangeClinicFee(newValue)}
                  value={clinicFeeSelected}
                  key={`clinic-fee-id`}
                  popupIcon={<span></span>}
                  disableClearable
                  clearOnBlur
                  clearOnEscape
                />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px' }} />
              </Grid>
            </Grid>
            <Box>
              <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>
                {t('OPERATIVE.INPUT.SETTING_OTHER')}
              </Typography>
              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <Typography>กำหนดสเตจปลายทางสำหรับการเลื่อนอัตโนมัติ</Typography>
                <RadioButton value={followUpState} name='followUpState' onChange={(e) => setFollowUpState(e.target.value)} row options={[{ label: 'ไม่ระบุ', value: '0' }, { label: '3', value: '3' }, { label: '4', value: '4' }]} />
              </Box>
              <CheckboxButton checked={operativeFixCode === '1'} label={t('OPERATIVE.INPUT.FIXCODE')} onChange={() => setOperativeFixCode(operativeFixCode === '0' ? '1' : '0')} />
              {/* <CheckboxButton checked={isXray === '1'} label={t('OPERATIVE.INPUT.IS_XRAY')} onChange={() => setIsXray(isXray === '0' ? '1' : '0')} /> */}
              <Box display="flex" flexDirection="row" alignItems="center" gap="32px">
                <CheckboxButton
                  checked={branchPrice === '1'}
                  label={t('OPERATIVE.INPUT.MANAGE_BRANCH_PRICE')}
                  onChange={() => handleChangeBranchPrice()}
                  disabled={isPriceRange === '1'}
                />
                <MainButton
                  startIcon={<MonetizationOnOutlinedIcon />}
                  disabled={branchPrice !== '1' || isPriceRange === '1'}
                  title={t('OPERATIVE.BRANCH_PRICE.SET_PRICE')}
                  type='primary'
                  variant='outlined'
                  onClick={() => onOpenModalManageBranch()}
                />
              </Box>
            </Box>
            <Box>
              <CheckboxButton
                label={t('OPERATIVE.INPUT.MANAGE_VITAL_SIGN')}
                checked={vitalSignState.isVitalSign}
                onChange={handleIsVitalSignChange}
              />
              <Collapse in={vitalSignState.isVitalSign}>
                <Box sx={{ mt: 2, pl: '28px' }}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <Grid container alignItems="center" sx={{ mb: 1 }}>
                        <Grid item xs={7}>
                          <Typography sx={{ fontWeight: 500 }}>Vital Sign</Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <CheckboxButton
                            label={t('FORMATFORM.REQUIRED')}
                            checked={isLeftAllChecked}
                            onChange={() => handleRequiredAllChange(leftColumnItems, !isLeftAllChecked)}
                          />
                        </Grid>
                      </Grid>
                      {leftColumnItems.map(item => (
                        <Grid container key={item.id} alignItems="center" sx={{ py: 0.5 }}>
                          <Grid item xs={7}>
                            <Typography>{t(`VITAL_SIGN.FORM.${item.text}`)}</Typography>
                          </Grid>
                          <Grid item xs={5}>
                            <CheckboxButton
                              label=""
                              checked={item.isRequired}
                              onChange={() => handleRequiredChange(item.id)}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>

                    <Grid item xs={6}>
                      <Grid container alignItems="center" sx={{ mb: 1 }}>
                        <Grid item xs={7}>
                        </Grid>
                        <Grid item xs={5}>
                          <CheckboxButton
                            label={t('FORMATFORM.REQUIRED')}
                            checked={isRightAllChecked}
                            onChange={() => handleRequiredAllChange(rightColumnItems, !isRightAllChecked)}
                          />
                        </Grid>
                      </Grid>
                      {rightColumnItems.map(item => (
                        <Grid container key={item.id} alignItems="center" sx={{ py: 0.5 }}>
                          <Grid item xs={7}>
                            <Typography>{t(`VITAL_SIGN.FORM.${item.text}`)}</Typography>
                          </Grid>
                          <Grid item xs={5}>
                            <CheckboxButton
                              label=""
                              checked={item.isRequired}
                              onChange={() => handleRequiredChange(item.id)}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Box>
              </Collapse>
            </Box>

            {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_TREATMENT) && (
              <Box>
                <CheckboxButton
                  checked={isXray === '1'}
                  label={t('OPERATIVE.INPUT.ALERT_WHEN_NO_TREATMENT') || 'แจ้งเตือนเมื่อไม่เลือกหัตถการ'}
                  onChange={() => setIsXray(isXray === '0' ? '1' : '0')}
                />
              </Box>
            )}

            <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px', width: '100%' }} />

            <Box>
              <Typography className="mb-3" sx={{ fontSize: '18px', fontWeight: 500 }}>
                {t('DIAGNOSIS.INPUT.DIAGNOSIS_NAME')}
              </Typography>
              <ButtonAddDiagnosis variant="text" disabled={disabledBtnAdd || disabledBtnAddDiagnosis} onClick={() => addDiagnosis()} sx={{ marginBottom: '1px', paddingBottom: '16px' }}>
                <span style={{ paddingRight: '8px' }}>+</span> {t('DIAGNOSIS.TITLE_CREATE')}
              </ButtonAddDiagnosis>
              {diagnoses
                .map((di: DiagnosesInterface, iDi: number) => (

                  <Box key={iDi} display="flex" flexDirection="row" alignItems="center" gap="16px" paddingBottom="16px">
                    <Typography style={{ width: '40px', flex: 'none', margin: 0 }}>
                      {iDi + 1}
                    </Typography>
                    <Box sx={{ width: { lg: '70% !important', xl: '60% !important' }, '#operative-unit-listbox': { height: 140 } }}>
                      <AutocompleteSelect
                        disableClearable
                        required={true}
                        onchange={(event, value) => {
                          handleSelectDiagnosis(value, iDi)
                          clearErrorMessage()
                        }}
                        inputLabel={t('DIAGNOSIS.INPUT.DIAGNOSIS_NAME')}
                        noOptionsText='ไม่พบข้อมูล'
                        labelId="operative-unit"
                        errMessage={di.diagnosisText === '' ? errorMessage.DIAGNOSIS_NAME : ''}
                        value={di.diagnosisText || ''}
                        options={diagnosesOption.map((option: any) => ({
                          value: option.diagnosisId,
                          label: option.diagnosisName || ''
                        }))}
                        clearIcon={<FontAwesomeIcon icon={faTimes} onClick={() => setDiagnoses((prev: any) => prev.map((item: any, index: number) => index === iDi ? { diagnosisId: null, diagnosisText: '' } : item))} />}
                        renderOption={(props, option: any) => {
                          return (
                            <Box
                              key={`${`diagnosisId-${option.diagnosisId}`}`}
                              component="li"
                              style={{
                                pointerEvents: _.some(diagnoses, (i: any, index: number) => i.diagnosisId === option.value) ? 'none' : '',
                                color: _.some(diagnoses, (i: any, index: number) => i.diagnosisId === option.value) ? "#9E9E9E" : null
                              }}
                              {...props}
                            >
                              <span>{option.label}</span>
                            </Box>
                          )
                        }}
                      />
                    </Box>
                    <IconButton disableFocusRipple disableRipple onClick={() => deleteDiagnoses(iDi)} sx={{ backgroundColor: 'transparent', padding: 0 }}>
                      <img src={icons.btnTrash} alt="discard" />
                    </IconButton>
                  </Box>
                ))
                .reverse()}

            </Box>

            <Box>
              <Typography className="mb-3" sx={{ fontSize: '18px', fontWeight: 500 }}>
                {t('OPERATIVE.INPUT.MED_PRODUCT_BIND')}
              </Typography>
              <ButtonAddDiagnosis variant="text"
                disabled={operativeProducts.some((item) => !item?.group || !item?.itemId || !item?.itemTypeId || !item?.qty)}
                onClick={() => addProducts()}
                sx={{ marginBottom: '1px', paddingBottom: '16px' }}
              >
                <span style={{ paddingRight: '8px' }}>+</span> {t('OPERATIVE.INPUT.MED_PRODUCT_ADDLIST')}
              </ButtonAddDiagnosis>
              {operativeProducts
                .map((item: BindProductProps, index: number) => {
                  return (
                    <BoxSelectMedPd
                      key={index}
                      index={index}
                      product={item}
                      handleProduct={handleProduct}
                      clearError={clearErrorMessage}
                      handleDelProduct={handleDelProduct}
                      productsError={productsError}
                      operativeProducts={operativeProducts}
                    />
                  )
                })
                .reverse()}
            </Box>
          </Box>
        </Box>
      </Box>
      <FormOpetaivesBranch
        onCloseModalManageBranch={onCloseModalManageBranch}
        manageBranch={operativePrice}
        handleChangeManageBranch={handleChangeManageBranch}
        handleChangeOperativePrice={handleChangeOperativePrice}
        operativeSalePrice={operativeSalePrice}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        state={popManageBranch}
        isPriceRange={isPriceRange}
      />
    </>
  )
}
